@if (vm$ | async; as vm) {
  <div
    class="bolt-container-fluid help-padding"
    [formGroup]="form"
    [nwxExposeFormErrors]="form"
    formName="member"
    [submitted]="submitted"
    >
    @if (vm.isPni && pniTasks?.length) {
      <div class="bolt-row">
        <div class="bolt-col">
          <nwx-tasks-policyholder-form
            [pniTasks]="pniTasks"
            [policyholder]="policyholder"
            [products]="products"
            (valueChange)="onValueChange($event)"
            (formReady)="addChildForm('pni', $event)"
            >
          </nwx-tasks-policyholder-form>
        </div>
        <div class="bolt-col">
          @if (vm.showMaritalStatus) {
            <div class="bolt-row">
              <div class="bolt-col" formGroupName="person">
                <bolt-select
                  required
                  ngDefaultControl
                  formControlName="maritalStatus"
                  label="Marital status"
                  name="maritalStatus"
                  attr.id="marital-status-{{ index }}"
                  >
                  <option value="S">Single</option>
                  <option value="M">Married</option>
                  <option value="P">Separated</option>
                  <option value="D">Divorced</option>
                  <option value="W">Widowed</option>
                </bolt-select>
              </div>
            </div>
          }
          @if (vm.showLicenseNumber) {
            <div class="bolt-row">
              <div class="bolt-col">
                <bolt-select
                  ngDefaultControl
                  formControlName="licenseState"
                  label="Licensed in state"
                  name="licenseState"
                  attr.id="license-state-{{ index }}"
                  class="no-help-padding-r"
                  >
                  @for (state of vm.states; track state) {
                    <option value="{{ state }}">
                      {{ state }}
                    </option>
                  }
                </bolt-select>
              </div>
            </div>
            <div class="bolt-row">
              <div class="bolt-col">
                <bolt-textfield
                  ngDefaultControl
                  formControlName="licenseNumber"
                  label="Driver's license number"
                  name="licenseNumber"
                  attr.id="license-number-{{ index }}"
                  instructionaltext="Required for bindable rate."
                  class="nwpii no-help-padding-r"
                ></bolt-textfield>
              </div>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="bolt-row">
        @if (vm.showLicenseNumber) {
          <div class="bolt-col">
            <bolt-select
              ngDefaultControl
              formControlName="licenseState"
              label="Licensed in state"
              name="licenseState"
              attr.id="license-state-{{ index }}"
              class="no-help-padding-r"
              >
              @for (state of vm.states; track state) {
                <option value="{{ state }}">
                  {{ state }}
                </option>
              }
            </bolt-select>
          </div>
        }
        @if (vm.showLicenseNumber) {
          <div class="bolt-col">
            <bolt-textfield
              ngDefaultControl
              formControlName="licenseNumber"
              label="Driver's license number"
              name="licenseNumber"
              attr.id="license-number-{{ index }}"
              instructionaltext="Required for bindable rate."
              class="nwpii no-help-padding-r"
            ></bolt-textfield>
          </div>
        }
        @if (vm.showMaritalStatus) {
          <div class="bolt-col" formGroupName="person">
            <bolt-select
              required
              ngDefaultControl
              formControlName="maritalStatus"
              label="Marital status"
              name="maritalStatus"
              attr.id="marital-status-{{ index }}"
              >
              <option value="S">Single</option>
              <option value="M">Married</option>
              <option value="P">Separated</option>
              <option value="D">Divorced</option>
              <option value="W">Widowed</option>
            </bolt-select>
          </div>
        }
        @if (vm.showRelationToPrimaryNamedInsured) {
          <div class="bolt-col">
            <bolt-select
              required
              ngDefaultControl
              formControlName="relationToPrimaryNamedInsured"
              label="Relationship to primary insured"
              name="relationToPrimaryNamedInsured"
              attr.id="relation-to-pni-{{ index }}"
              class="no-help-padding-r"
              >
              @for (option of vm.relationToPrimaryNamedInsuredOptions; track option.value) {
                <option
                  value="{{ option.value }}"
                  >
                  {{ option.display }}
                </option>
              }
            </bolt-select>
          </div>
        }
      </div>
    }
  </div>
}
